import type { IApiRoutes } from '../ApiRoutes';
import { ProductionApiRoutes } from './ProductionApiRoutes';

export const OfflineApiRoutes: IApiRoutes = {
    ...ProductionApiRoutes,

    canUseApi(): boolean {
        return false;
    },
};
